import {call, put, takeLatest} from 'redux-saga/effects';
import AveragePlayTimeApi from '../../api/AveragePlayTimeApi';
import averagePlayTimeActions from '../../actions/fortnite-game/averagePlayTime.actions';
import getErrorCodeFromResponse from '../../utils/errors/getErrorCodeFromResponse';
import {NO_DATA_ERROR_CODE} from './constants';

function* getAveragePlayTime(action) {
    try {
        delete action.payload.silent;

        const {data} = yield call(AveragePlayTimeApi.getData, action.payload);
        yield put(
            averagePlayTimeActions.getAveragePlayTimeSuccess({
                data,
                error: data.list && data.list.length ? undefined : NO_DATA_ERROR_CODE
            })
        );
    } catch (e) {
        yield put(averagePlayTimeActions.getAveragePlayTimeFailed(getErrorCodeFromResponse(e), e));
    }
}

function* averagePlayTimeSaga() {
    yield takeLatest(averagePlayTimeActions.TYPES.GET_AVERAGE_PLAY_TIME, getAveragePlayTime);
}

export default averagePlayTimeSaga;
